module.exports = __webpack_public_path__ + "img/transport_and_flight_delays_icon.1f90287b.webp";